<!-- Documentation Page -->
<div class="container-fluid vh-100 d-flex flex-column">
  <!-- Header with Back Button -->
  <div class="bg-linear-gradient-purple text-white py-3 shadow-sm">
    <div class="container-fluid px-4">
      <div class="d-flex align-items-center">
        <button class="btn btn-link text-white p-0 me-3" (click)="goBack()">
          <i class="bi bi-arrow-left fs-4"></i>
        </button>
        <div>
          <h4 class="mb-0">
            <i class="bi bi-book me-2"></i>App Documentation
          </h4>
          <p class="mb-0 opacity-75 small">Learn how to use the app</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="flex-grow-1 overflow-hidden">
    <div class="row g-0 h-100">
      <!-- Sidebar Navigation -->
      <div class="col-md-4 col-lg-3 border-end bg-light overflow-auto h-100">
        <div class="p-3">
          <!-- Search Bar -->
          <div class="mb-3">
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-search text-muted"></i>
              </span>
              <input
                type="text"
                class="form-control border-start-0 ps-0"
                placeholder="Search topics..."
                [(ngModel)]="searchQuery"
                (input)="onSearch($event)"
              />
              <button
                *ngIf="searchQuery"
                class="btn btn-sm btn-outline-secondary"
                type="button"
                (click)="clearSearch()"
              >
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>

          <!-- Category List -->
          <div class="list-group list-group-flush">
            <button
              *ngFor="let section of documentationSections"
              type="button"
              class="list-group-item list-group-item-action border-0 rounded mb-1"
              [class.active]="activeSection === section.id"
              (click)="setActiveSection(section.id)"
            >
              <div class="d-flex align-items-center">
                <i class="bi {{ section.icon }} me-2 fs-5"></i>
                <div class="flex-grow-1">
                  <div class="fw-semibold small">{{ section.title }}</div>
                  <div class="text-muted" style="font-size: 0.75rem">
                    {{ section.topics.length }} topics
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <!-- Content Area -->
      <div class="col-md-8 col-lg-9 overflow-auto h-100">
        <div class="p-4">
          <!-- Section Header -->
          <div *ngIf="currentSection && !searchQuery" class="mb-4">
            <div class="d-flex align-items-center mb-2">
              <div
                class="bg-linear-gradient-purple text-white rounded-circle p-2 me-3"
                style="width: 48px; height: 48px; display: flex; align-items: center; justify-content: center;"
              >
                <i class="bi {{ currentSection.icon }} fs-4"></i>
              </div>
              <div>
                <h3 class="mb-0">{{ currentSection.title }}</h3>
                <p class="text-muted mb-0 small">
                  {{ currentSection.description }}
                </p>
              </div>
            </div>
          </div>

          <!-- Search Results Header -->
          <div *ngIf="searchQuery" class="mb-4">
            <h4>
              <i class="bi bi-search me-2"></i>Search Results
            </h4>
            <p class="text-muted">
              Found {{ filteredSections.length }} section(s) matching "{{
                searchQuery
              }}"
            </p>
          </div>

          <!-- Topics/Accordion -->
          <div class="accordion" id="documentationAccordion">
            <!-- Show current section topics when not searching -->
            <div *ngIf="currentSection && !searchQuery">
              <div
                *ngFor="let topic of currentSection.topics; let i = index"
                class="accordion-item border mb-2 rounded"
              >
                <h2 class="accordion-header" [id]="'heading' + i">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#collapse' + i"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapse' + i"
                  >
                    <i class="bi bi-question-circle me-2 text-primary"></i>
                    <strong>{{ topic.question }}</strong>
                  </button>
                </h2>
                <div
                  [id]="'collapse' + i"
                  class="accordion-collapse collapse"
                  [attr.aria-labelledby]="'heading' + i"
                  data-bs-parent="#documentationAccordion"
                >
                  <div class="accordion-body">
                    <p class="mb-3">{{ topic.answer }}</p>

                    <!-- Steps -->
                    <div *ngIf="topic.steps && topic.steps.length > 0" class="mb-3">
                      <h6 class="fw-semibold mb-2">
                        <i class="bi bi-list-ol me-2 text-primary"></i>Steps:
                      </h6>
                      <ol class="mb-0">
                        <li *ngFor="let step of topic.steps" class="mb-1">
                          {{ step }}
                        </li>
                      </ol>
                    </div>

                    <!-- Images -->
                    <div *ngIf="topic.images && topic.images.length > 0" class="mb-3">
                      <h6 class="fw-semibold mb-2">
                        <i class="bi bi-images me-2 text-primary"></i>Visual Guide:
                      </h6>
                      <div class="row g-2">
                        <div 
                          *ngFor="let image of topic.images" 
                          class="col-6 col-md-3"
                        >
                          <img 
                            [src]="image" 
                            [alt]="'Step ' + (topic.images.indexOf(image) + 1)"
                            class="img-fluid rounded shadow-sm documentation-image"
                            style="cursor: pointer;"
                            (click)="openImageModal(image)"
                          />
                          <p class="text-center text-muted small mt-1 mb-0">
                            Step {{ topic.images.indexOf(image) + 1 }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- Tips -->
                    <div *ngIf="topic.tips && topic.tips.length > 0" class="alert alert-info mb-0">
                      <h6 class="fw-semibold mb-2">
                        <i class="bi bi-lightbulb me-2"></i>Tips:
                      </h6>
                      <ul class="mb-0" style="padding-left: 1.2rem;">
                        <li *ngFor="let tip of topic.tips" class="mb-1">
                          {{ tip }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Show all matching topics when searching -->
            <div *ngIf="searchQuery">
              <div *ngFor="let section of filteredSections" class="mb-4">
                <h5 class="mb-3">
                  <i class="bi {{ section.icon }} me-2"></i>{{ section.title }}
                </h5>
                <div
                  *ngFor="let topic of section.topics; let i = index"
                  class="accordion-item border mb-2 rounded"
                >
                  <h2
                    class="accordion-header"
                    [id]="'search-heading-' + section.id + '-' + i"
                  >
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#search-collapse-' + section.id + '-' + i"
                      aria-expanded="false"
                      [attr.aria-controls]="'search-collapse-' + section.id + '-' + i"
                    >
                      <i class="bi bi-question-circle me-2 text-primary"></i>
                      <strong>{{ topic.question }}</strong>
                    </button>
                  </h2>
                  <div
                    [id]="'search-collapse-' + section.id + '-' + i"
                    class="accordion-collapse collapse"
                    [attr.aria-labelledby]="'search-heading-' + section.id + '-' + i"
                  >
                    <div class="accordion-body">
                      <p class="mb-3">{{ topic.answer }}</p>

                      <!-- Steps -->
                      <div *ngIf="topic.steps && topic.steps.length > 0" class="mb-3">
                        <h6 class="fw-semibold mb-2">
                          <i class="bi bi-list-ol me-2 text-primary"></i>Steps:
                        </h6>
                        <ol class="mb-0">
                          <li *ngFor="let step of topic.steps" class="mb-1">
                            {{ step }}
                          </li>
                        </ol>
                      </div>

                      <!-- Images -->
                      <div *ngIf="topic.images && topic.images.length > 0" class="mb-3">
                        <h6 class="fw-semibold mb-2">
                          <i class="bi bi-images me-2 text-primary"></i>Visual Guide:
                        </h6>
                        <div class="row g-2">
                          <div 
                            *ngFor="let image of topic.images" 
                            class="col-6 col-md-3"
                          >
                            <img 
                              [src]="image" 
                              [alt]="'Step ' + (topic.images.indexOf(image) + 1)"
                              class="img-fluid rounded shadow-sm documentation-image"
                              style="cursor: pointer;"
                              (click)="openImageModal(image)"
                            />
                            <p class="text-center text-muted small mt-1 mb-0">
                              Step {{ topic.images.indexOf(image) + 1 }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <!-- Tips -->
                      <div *ngIf="topic.tips && topic.tips.length > 0" class="alert alert-info mb-0">
                        <h6 class="fw-semibold mb-2">
                          <i class="bi bi-lightbulb me-2"></i>Tips:
                        </h6>
                        <ul class="mb-0" style="padding-left: 1.2rem;">
                          <li *ngFor="let tip of topic.tips" class="mb-1">
                            {{ tip }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- No Results -->
              <div *ngIf="filteredSections.length === 0" class="text-center py-5">
                <i class="bi bi-search display-1 text-muted opacity-25"></i>
                <h5 class="mt-3 text-muted">No results found</h5>
                <p class="text-muted">
                  Try searching with different keywords or browse the categories
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Image Modal for Fullscreen View -->
<div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-body p-0 position-relative">
        <button 
          type="button" 
          class="btn-close btn-close-white position-absolute top-0 end-0 m-3" 
          data-bs-dismiss="modal" 
          aria-label="Close"
          style="z-index: 10;"
        ></button>
        <img 
          [src]="selectedImage" 
          class="img-fluid rounded" 
          alt="Full size view"
          *ngIf="selectedImage"
        />
      </div>
    </div>
  </div>
</div>